import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AttributeOverrideRow } from 'src/app/models/attribute-override-row';
import { OverrideCondition } from 'src/app/models/enums/override-condition';
import { AttributeOverrideDialogData } from './models/attribute-override-dialog-data';
import { AttributeOverrideDialogResult } from './models/attribute-override-dialog-result';

import { FormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { FormFocusDirective } from '../../../../../controls/directives/form-focus.directive';

@Component({
    selector: 'app-attribute-override-dialog',
    templateUrl: './attribute-override-dialog.component.html',
    styleUrls: ['./attribute-override-dialog.component.scss'],
    imports: [MatCardModule, FormsModule, FormFocusDirective, MatFormFieldModule, MatSelectModule, MatOptionModule, MatButtonModule]
})
export class AttributeOverrideDialogComponent {
    row: AttributeOverrideRow;

    public overrideCondition: OverrideCondition;
    public attributeName: string;
    public attributeId: number;

    constructor(
        public dialogRef: MatDialogRef<AttributeOverrideDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: AttributeOverrideDialogData
    ) {
        console.log('AttributeOverrideDialogComponent data : ', data);

        if (data.row != null) {
            this.row = data.row;
            this.attributeName = data.row.attributeName;
            this.overrideCondition = data.row.overrideCondition;
            this.attributeId = data.row.attributeId;
        }
    }

    onConfirm(): void {
        if (this.row == null) {
            this.row = new AttributeOverrideRow();
        }

        this.row.attributeId = this.attributeId;

        let attribute = this.data.attributes.find((x) => x.id == this.attributeId);
        this.row.attributeName = attribute.header;
        this.row.overrideCondition = this.overrideCondition;

        var result = new AttributeOverrideDialogResult(true, this.row);
        // Close the dialog, return true
        this.dialogRef.close(result);
    }

    onDismiss(): void {
        var result = new AttributeOverrideDialogResult(false);
        // Close the dialog, return false
        this.dialogRef.close(result);
    }
}
